import {
  userApi,
  type UsersTableSuccessResponse,
  type UserTableRequestPayload,
} from "@repo/api";
import { useInfiniteQuery } from "@tanstack/react-query";
import { userQueryKeys } from "../../../pages/IspmUsers/queryKeys";

export const useUsersTable = (payload: UserTableRequestPayload) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetchingNextPage,
    error,
  } = useInfiniteQuery<UsersTableSuccessResponse>({
    initialPageParam: null,
    enabled: true,
    retry: false,
    queryKey: [...userQueryKeys.lists(), payload],
    queryFn: ({ pageParam }) =>
      userApi.getUsers({
        pageParam: pageParam as string,
        payload,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPageToken || undefined,
  });

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isLoading, // Initial load
    isFetchingNextPage, // When fetching the next page
  };
};
